import styles from './TitleSection.module.scss';

type PropsType = {
  label: string;
  subtitle?: string;
};

export const TitleSection = ({ label, subtitle }: PropsType) => (
  <section className={styles.titleSection}>
    <h2 className={styles.title}>{label}</h2>
    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
  </section>
);
